
const freshers="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/fresherslogo.webp"
const music="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/musiclogo.webp"
const muthamizh="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/muthamizhlogo.webp"
const leo="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/leologo.webp"
const rotaract="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/rotractlogo.webp"
const build="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/buildlogo.webp"
const mediaclub ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/mediaclub.webp"
const image1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/rotracthero.webp"
const image2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers.webp"
const image3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/leo.webp"
const image4="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/MUTHAMIL.webp"
const image5="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/music.webp"
const image6="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Build_club.webp"
const GAME_CLUB="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/game_club_logo.webp"
const LAGARAM_CLUB="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/lagaram_club.webp"
//const Clubs_heroimage_carousalinfo = {
  //id: 1,
  //title: "Clubs at ACGCET",
  //img_list: [image1, image2,image3,image4,image5,image6],
//};

/*const slideshow_imgs_club= [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6
]*/
const clubs_heroimage_carousalinfo = {
  id: 1,
  title: "Clubs At ACGCET",
  img_list: [image1, image2, image3, image4,image5,image6],
};
const Clubs_info = [
  {
    id: "6",
    logoimg: build,
    title: "Build Club ",
    maillink: "mailto:mailto:buildclubofficial@gmail.com",
    instalink: "https://instagram.com/buildclub.acgcet?igshid=MzRlODBiNWFlZA==",
    para: "A MoU between IIT MADRAS RESEARCH PARK (IITMRP) and ACCETOSA established the technical club named “Build Club” to help ACCET students advance their technical knowledge and implement creative ideas that can then be developed into working products under the direction of Build Club Associates from IITMRP and ACCET on July-2022 . It creates a culture of building using cross-disciplinary knowledge from which creativity originates. By promoting a culture of building and innovation, this initiative can help instill an entrepreneurial spirit among students. They can learn to think beyond textbooks and apply their knowledge to real-world problems. Build Club can span a wide range of technical projects, encompassing fields such as engineering, computer science, electronics, and more. This diversity ensures that students have the opportunity to explore their interests and develop skills in their chosen areas. Collaboration with IITMRP opens doors to cutting-edge research opportunities. ACCET students may have the chance to participate in conference’s led by IITMRP faculty and researchers, exposing them to the latest advancements in technology in their chosen areas and building a wide range of professional network with scholars and research faculty.",
    staff: "Dr.S.M.Kavitha",
    staffdesi: "Associate Professor/Civil",
    student: "Praveen Maari M",
    studentdesi: "3rd year EEE",
    infolink:"/clubs/build_club",
  },
  {
    id: "1",
    logoimg: rotaract,
    title: "Rotaract Club",
    maillink: "mailto:rotaractclubofacgcet@gmail.com",
    instalink: "https://www.instagram.com/rotaract_acgcet/",
    para: "The aim of our club is to bring out the service and leadership quality of individuals by involving them in various social activities and coordinating their fellow juniors.Our vision is to develop professional and leadership skills of every individuals.The mission of our club is to provide opportunities for the youth to enhance their personal development skills, to address the social needs of the society by creating better relationships and gaining knowledge in all aspects. The main obejective of our club is to advance the world with goodwill, providing quality education, improving the environment, and alleviating poverty and also to emphasize ethical standards with better leadership qualities.The planned activities include installation, treasure hunt, awareness program, orphanage visit, planting saplings, tutoring government school students, and participating in RYLA (Rotary Youth Leadership Awards).",
    staff: "Mr. Ramados",
    staffdesi: "Asst.Prof. EEE Dept",

    student: "Nithish Kumar A  ",
    studentdesi: "4th year Mech",
    infolink:"",
  },

  {
    id: "5",
    logoimg: freshers,
    title: "Freshers' Association",
    maillink: "mailto:freshers.asso@gmail.com",
    instalink: "https://www.instagram.com/freshers_association_of_accet/",
    para: "ACGCET is dedicated to cultivating a sense of community, camaraderie, and innovation among incoming students, as evidenced by the Fresher's Association. This platform serves as a welcoming and integrative space, facilitating the seamless transition of new students into the dynamic college environment while offering avenues for personal growth, learning, and enjoyment. The mission of the Fresher's Association is rooted in creating an inclusive and inviting atmosphere for newcomers, aiding their smooth adjustment to college life. The goal is to nurture their innate talents, provide support for their aspirations, and empower them to evolve into holistic individuals capable of making positive contributions not only within the college community but also in broader contexts. The Association achieves this through initiatives like comprehensive campus tours, specialized workshops leading to valuable certifications spanning leadership and technical skills, and the vibrant Fresher's Day celebrated every Tuesday, replete with engaging events, competitions, and activities, fostering unity, mirth, and a well-deserved respite from academic pursuits.",
    staff: "Dr.S.R.Cynthia",
    staffdesi: "Assistant Professor/Physics",
    student: "Madasamy I",
    studentdesi: "4th year CSE",
    infolink:"",
  },

  {
    id: "2",
    logoimg: leo,
    title: "Leo Club",
    maillink: "mailto:leoclubofacgcet@gmail.com",
    instalink: "https://www.instagram.com/leo_club_of_acgcet/",
    para: "The primary aim of the club is to inspire young individuals to cultivate leadership traits through active engagement in various social service endeavors. The club envisions becoming a worldwide frontrunner in initiatives related to community and humanitarian assistance. Its mission is centered on equipping volunteers with the means to make impactful contributions to their communities, address humanitarian concerns, and promote the ideals of peace. The core objectives encompass affording youth the chance to evolve into responsible contributors within their local, national, and international spheres. The club's planned activities encompass a range of events such as treasure hunts and inaugurations, all aimed at fostering personal development and community involvement among its members.",
    staff: "Dr.K. Padmanabhan",
    //

    staffdesi: "Assistant Professor/EEE",
    student: "AnushKumar G  ",
    studentdesi: "4th year Mechanical",
    infolink:"",
  },
  //

  {
    id: "3",
    logoimg: muthamizh,

    title: "முத்தமிழ் மன்றம்",
    maillink: "mailto:naniidhal2k20@gmail.com",
    instalink: "https://www.instagram.com/nani_idhal_acgcet/",
    para: "முத்தமிழ் மன்றம், தமிழ்மொழி மற்றும் கலாச்சாரங்களை மாணவர்களிடையே வளர்த்துப் போற்றுவதற்காக உருவாக்கப்பட்டது. இது, தமிழின் வரலாறு மற்றும் கலாச்சார விழுமியங்களைப் பரப்பி, மாணவர்களின் தமிழ்த்திறனை மேம்படுத்தவும், அவர்களின் தனித்திறன்களை வெளிக்கொணரவும் நடவடிக்கைகள் மேற்கொள்ளும். போட்டிகள், கலாச்சார நிகழ்ச்சிகள், மற்றும் அறநிலையப் பொழிவுகள் மூலம் தமிழ் மொழியின் மீது மாணவர்களின் ஆர்வத்தை ஊக்குவிக்கிறது. ஆண்டுதோறும் முத்தமிழ் விழாக்கள், கலைக்குழுக்கள், மற்றும் தமிழ்ச் சங்கங்களுடன் இணைந்து நிகழ்ச்சிகளை நடத்தி, மாணவர்களின் திறமைகளை வெளிக்கொணருகிறது. 'அகழ்', 'விடியல்', மற்றும் 'சமத்துவ பொங்கல்' போன்ற விழாக்களும் மாணவர்களின் இடையே பிரம்மாண்டத்தின் விருந்தாகுகிறது. மாணவர்களின் தனித்திறன்கள் மற்றும் முத்தமிழ் மன்ற நிகழ்வுகளைத் தொகுத்து காலம் கடந்து அழியா நினைவு கூறும் சுவடாக 'சங்கமம் இதழ்' யை வெளியிடுகிறது. மேலும், பிற கல்லூரிகள் மற்றும் மாவட்ட அளவிலான போட்டிகளிலும் மாணவர்களை ஈடுபடுத்தி, அவர்களின் திறமைகளைப் பரப்புவதிலும் மன்றம் முக்கிய பங்காற்றுகிறது.",
    staff: "முனைவர். மு. தேன்ராஜ்",
    staffdesi: "Assistant Professor/Chemistry",
    student: "Vishal K",
    studentdesi: "4th year ECE",
  },


  {
    id: "4",
    logoimg: music,
    title: "Music Club",
    maillink: "mailto:musicclubacgcet@gmail.com",
    instalink: "https://www.instagram.com/music_club_acgcet/",
    para: "Music Club ACGCET is one of the actively performing clubs in our college,  which was started with the objective to find the musical talents  of students in our college such as singing, playing instruments and producing music etc.The members of music club usually entertain the audience by performing in college events such as symposiums, club inauguration functions and cultural fests. Also, our Music Club and Rotaract Club of our college together organize a grand musical event in the name of “Shrishti” every year for a good cause. Tickets will be sold and a big part of the collection will be provided for orphanages. To take our club to the next level, we have been training our members by conducting practice sessions so that we can represent our college in intercollege musical events as a ‘band’ and give appreciable performance. With this intention,we have named our club – ‘BAND AROHANAM’.",
    staff: "Dr.K. Padmanabhan",
    staffdesi: "Assistant professor EEE",
    student: "Gowri S",
    studentdesi: "4th year EEE",
    infolink:"",
  },
  {
    id: "7",
    logoimg: mediaclub,
    title: "Media Club",
    maillink: "mailto:mediaclubofacgcet@gmail.com",
    instalink: "https://www.instagram.com/media_club_of_accet?igsh=MW9qYjVhODF5Z3hydg==",
    para: "Media Club ACGCET is a vibrant platform dedicated to capturing and showcasing the creativity and energy of our college. We specialize in photography, videography, editing, content creation, and social media management. Our club plays a key role in covering college functions, symposiums, and cultural events while also producing engaging digital content. Beyond event coverage, we bring stories to life through short films, reels, and creative video projects. With a passion for storytelling and innovation, the Media Club enhances campus experiences through the dynamic art of media.",
    staff: "Dr. G. Karpagarajesh ,",
    staffdesi: "HOD ECE",
    student: "Gnanavalli L ",
    studentdesi: "4th year CSE",
    infolink: "",
    videolink:"https://www.youtube.com/embed/D15uUuNgxRI?si=t_bd04kiY6NWm7BT"
    
},
{
    id: "8",
    logoimg:GAME_CLUB,
    title: "GameJam Club",
    maillink: "mailto:sniranj2007@gmail.com",
    instalink: "https://www.instagram.com/gamejam._of_.acgcet/",
    para: `
GameJam Club ACGCET is dedicated to cultivating creativity, innovation, collaboration, and practical learning among students through the exciting world of game development and interactive technology. The club serves as a creative platform where students from different departments can come together to learn, experiment, share ideas, and transform their imagination into meaningful digital experiences.
The primary mission of GameJam Club is to provide students with opportunities to explore and develop skills beyond the classroom. Through workshops, game jams, hands-on projects, competitions, industry exposure, and collaborative activities, students can gain practical experience in areas such as game design, programming, Unity, Godot, Blender, 2D and 3D art, animation, storytelling, music, sound design, video editing, and creative design.
The club aims to build a strong game development culture within ACGCET by encouraging students to work in teams, develop complete projects, showcase their creations, and participate in competitions and hackathons. By bringing together students with diverse talents, GameJam Club promotes interdisciplinary collaboration, problem-solving, leadership, communication, and teamwork.
Beyond student development, the club strives to contribute to the growth and creative identity of the college by representing ACGCET through innovative projects, games, events, and student achievements. We believe that games are not merely a source of entertainment but can also become powerful tools for education, awareness, culture, creativity, and social impact.
GameJam Club also encourages students to explore entrepreneurship and transform their skills and ideas into real-world opportunities. By supporting innovation, creative projects, and student-led initiatives, the club aims to inspire future startups and create opportunities within the growing gaming and interactive technology industry.
With a vision to benefit students, strengthen the college community, create future startups, and contribute positively to society, GameJam Club strives to empower young creators to learn, collaborate, innovate, and build experiences that can make a meaningful impact beyond the classroom.`,
    staff: "Dr.G.Dhevanandhini",
    staffdesi: "Assistant Professor/ECE",
    student: "Niranjan Kumar ",
    studentdesi: "2nd Year ECE",
    infolink: "https://drive.google.com/file/d/14xYMK8k5t3R2pfmclMmVKfrf916I9K2n/view?usp=sharing",
    // videolink:""
},
{
  id: "9",
  logoimg:LAGARAM_CLUB,
  title: "ழகரம் club",
 maillink: "mailto:zhagaramacgcet27@gmail.com",
  instalink: "https://www.instagram.com/zhagaram_acgcet/",
  para: `Zhagaram Cultural Club at ACGCET is a vibrant platform dedicated to celebrating creativity, culture, talent, and togetherness among students. The club provides an inclusive space where students can discover their interests, express themselves freely, showcase their talents, and build meaningful connections beyond the boundaries of academics. The club aims to encourage students to explore and develop their artistic, creative, and cultural abilities while fostering confidence, teamwork, leadership, and a strong sense of belonging. Through a diverse range of cultural events, competitions, celebrations, workshops, and student-driven initiatives, Zhagaram creates opportunities for every student to participate, learn, perform, and grow. From traditional celebrations to contemporary cultural activities, the club brings together students from different backgrounds and interests, creating an atmosphere filled with creativity, unity, joy, and self-expression. These initiatives not only provide a refreshing break from academic routines but also help students discover their potential and create memorable experiences throughout their college journey. At its heart, Zhagaram Cultural Club strives to make campus life more vibrant by providing a stage for every talent, a space for every idea, and a community where students can connect, create, celebrate, and grow together`,
  staff: "Prof.K.Padmanaban",
  staffdesi: " Assistant Professor/Mechanical",
  student: "Praveen Kumar S",
  studentdesi: "4th year Mech",
  // infolink: "",
  // videolink:""   
}

];

const build_club_reports=[
  {
      'id':"2",
      "head":"2023-2024",
      "house":"right",
      "pdf":"https://drive.google.com/file/d/1svCpM7GKbQqKKpHxdk896Av3y_eVJ0qf/view?usp=drive_link"
  },
  {
      'id':"1",
      "head":"2022-2023",
      "house":"left",
      "pdf":"https://drive.google.com/file/d/18ayxlleEEkwUmaxLWkCsghg-msRoPyKl/view?usp=drive_link"
  }
]
const Club_Activity=[
   {
    id:1,
    program:'Club Activity Report 2024-2025',
    pdf:'https://drive.google.com/file/d/1dZM2SLyJJzGCAIFiTSpj1WQSlksZWvjh/view?usp=sharing'
  },
  {
    id:2,
    program:'Club Activity Report 2023-2024',
    pdf:'https://drive.google.com/file/d/1CybUebi_LHDX_6CJJexJ3OpGMNsWqA_n/view?usp=sharing'
  }
]

const Music_Club_Activity=[
  {
    id:1,
    program:'Activity Report 2024-2025',
    pdf:'https://drive.google.com/file/d/1aig2oYPudVT8ZHksHG6VcT0oJa3jM5Dq/view?usp=sharing'
  },
  {
    id:2,
    program:'Activity Report 2023-2024',
    pdf:'https://drive.google.com/file/d/1TKZWUZlgKqAzZB63vshGvXOq-0E8INR6/view?usp=sharing'
  }
]
export { clubs_heroimage_carousalinfo, Clubs_info,build_club_reports,Club_Activity,Music_Club_Activity };
